var ActiveNav = (function () {
    function ActiveNav() {
        this.navi = document.querySelectorAll('header nav a');
        this.url = location.pathname;
        this.urlDirLength = this.url.split('/').length;
        this.urlFileName = this.url.split('/')[this.urlDirLength - 1];
        this.urlDirName = this.url.split('/')[this.urlDirLength - 2];
    }
    ActiveNav.prototype.isHighlight = function (href) {
        var returnBool = false;
        var hrefDirLength = href.split('/').length;
        if (this.urlDirLength === hrefDirLength) {
            if (this.urlDirName === '') {
                var hrefPageName = href.split('/')[hrefDirLength - 1];
                if (this.urlFileName === hrefPageName || (this.urlFileName === '' && hrefPageName === 'index.html')) {
                    returnBool = true;
                }
            }
            else {
                var hrefDirName = href.split('/')[hrefDirLength - 2];
                if (this.urlDirName === hrefDirName) {
                    returnBool = true;
                }
            }
        }
        return returnBool;
    };
    ActiveNav.prototype.execute = function () {
        var _this = this;
        this.navi.forEach(function (element) {
            var href = element.getAttribute('href') || '';
            if (_this.isHighlight(href)) {
                element.classList.add('current');
            }
        });
    };
    return ActiveNav;
}());
export default ActiveNav;
